import { Amplify } from 'aws-amplify';
import { environment } from '../../../environments/environment';

export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: environment.cognito.userPoolId,
        userPoolClientId: environment.cognito.userPoolWebClientId,
        identityPoolId: environment.cognito.identityPoolId,
        loginWith: {
          oauth: {
            domain: environment.cognito.domain,
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [environment.cognito.redirectSignIn],
            redirectSignOut: [environment.cognito.redirectSignOut],
            responseType: 'code',
          },
        },
      },
    },
  });
}
